import styled from "styled-components";
import Select from "react-select";

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  gap: var(--space-16);
`;

export const Input = styled.input`
  width: 200px;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-8);
  align-items: center;
`;

export const CustomSelect = styled(Select)`
  width: 200px;
`;
